import { render, staticRenderFns } from "./inactiveMembers.vue?vue&type=template&id=3a475f7d&scoped=true&"
import script from "./inactiveMembers.vue?vue&type=script&lang=js&"
export * from "./inactiveMembers.vue?vue&type=script&lang=js&"
import style0 from "./inactiveMembers.vue?vue&type=style&index=0&id=3a475f7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a475f7d",
  null
  
)

export default component.exports